<script lang="ts">
    import cn from 'classnames';

    import { IconName, SvgIcon, SvgIconTypes } from '@uikit/svg-icon';

    import { Size } from '../../types';

    import s from './retired.module.css';

    export let size: Size;
</script>

<div class={cn(s.retired, s[size])}>
    <SvgIcon icon={IconName.RetiredAvatar} color={SvgIconTypes.Color.disabled} />
</div>
